export default [

    { label:'编码:',spanRows:8,type:'input',modelValue:'code'},
    { label:'名称:',spanRows:8,type:'input',modelValue:'name'},
    { label:'可用状态:',spanRows:8,type:'select',modelValue:'state',op:'unitStateOption'},
    { label:'所属地域:',spanRows:8,type:'select',modelValue:'area',op:'areaOption'},
    { label:'拼音简码:',spanRows:8,type:'input',modelValue:'pyCode',disabled: true},
    { label:'开户行:',spanRows:8,type:'input',modelValue:'bankName'},
    { label:'开户账号:',spanRows:8,type:'input',modelValue:'bankNo'},
    { label:'生产许可证:',spanRows:8,type:'input',modelValue:'splerPmtno'},
    { label:'法人代表:',spanRows:8,type:'input',modelValue:'legalRepe'},
    { label:'联系人:',spanRows:8,type:'input',modelValue:'mainConer'},
    { label:'联系手机:',spanRows:8,type:'input',modelValue:'conerPhone'},
    { label:'联系人电话:',spanRows:8,type:'input',modelValue:'conerTel'},
    { label:'联系QQ:',spanRows:8,type:'input',modelValue:'conerQq'},
    { label:'传真电话:',spanRows:8,type:'input',modelValue:'conerFax'},
    { label:'邮政编码:',spanRows:8,type:'input',modelValue:'conerPostcode'},
    { label:'网址:',spanRows:8,type:'input',modelValue:'url'},
    { label:'电子邮件:',spanRows:8,type:'input',modelValue:'conerMail'},
    { label:'单位属性:',spanRows:20,type:'select',modelValue:'untAtte',op:'untAtteOption'},
    { label:'统一社会信用代码:',spanRows:16,type:'input',modelValue:'uscc'},
    { label:'联系地址:',spanRows:20,type:'input',modelValue:'conerAdd'},
    { label:'备注:',spanRows:20,type:'input',modelValue:'remark'},

]